import styled from 'styled-components';

export const CBORankingSes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5rem 4%;
  @media screen and (max-width: 414px) {
    padding: 3rem 4%;
  }
`;
export const CBORankingSesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1210px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;
export const CBORankingSesCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffff;
  width: 100%;
  height: 600px;
  border-radius: 2.3rem;
  padding: 3.5%;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
`;
export const CBORankingSesCardGraphContainer = styled.div`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const CBORankingSesCardHeader = styled.p`
  text-align: center;
  font-weight: bold;
  color: #071242;
`;
